var md5 = require('md5')
var opt = require('./opt');
var cookie = require('./cookie');

var util = module.exports = {
    /**
     * @func getReferfrom
     * @desc 获取站点来源
     * @returns {string} 返回referfrom
     */
    getReferfrom: function () {
        var referfrom = util.getParameter('referfrom');
        if (referfrom) {
            cookie.set(document.domain, 'XLA_RF' + opt.appid, referfrom, 24);
        } else {
            referfrom = cookie.get('XLA_RF' + opt.appid);
        }
        return referfrom;
    },

    /**
     * @func getCookieId
     * @desc 获取cookieid
     * @returns {string} 返回cookieId
     */
    getCookieId: function () {
        var cookieId = cookie.get('XLA_CI');
        if (!cookieId) {
            var random = Math.random();
            var browser = navigator.appName + "_" + navigator.appVersion + "_" + navigator.userAgent + "_" + navigator.appCodeName + "_" + navigator.platform;
            var nowtime = new Date().valueOf();
            cookieId = md5(nowtime + browser + random);
            cookie.set(document.domain, 'XLA_CI', cookieId, 24);
        }
        return cookieId;
    },

    /**
     * @func
     * @desc 获取链接参数
     * @param {string} name - 参数字段
     * @returns {string} 返回参数值或null
     */
    getParameter: function (name) {
        var pattern = new RegExp("[?&]" + name + "\=([^&#]+)", "g");
        try {
            var matcher = pattern.exec(document.location.href);
        } catch (e) {
        }
        ;
        if (null != matcher) {
            return decodeURIComponent(matcher[1]);
        } else {
            return null;
        }
    },

    /**
     * @func deepExtend
     * @desc 深度拓展对象
     * @returns {object} 返回拓展好的对象
     */
    deepExtend: function (out) {
        out = out || {};

        for (var i = 1; i < arguments.length; i++) {
            var obj = arguments[i];

            if (!obj)
                continue;

            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (typeof obj[key] === 'object' && obj[key] !== null)
                        out[key] = this.deepExtend(out[key], obj[key]);
                    else
                        out[key] = obj[key];
                }
            }
        }

        return out;
    },

    /**
     * @type {object}
     * @desc 打印错误日志
     */
    print: {
        msg: function (msg) {
            if (window.console && window.console.info) {
                console.info(msg);
            }
        },
        err: function (err) {
            if (window.console && window.console.error) {
                console.error(err);
            }
        }
    },

    /**
     * @func on
     * @desc 事件绑定
     */
    on: function (el, eventName, handler) {
        if (el.addEventListener) {
            el.addEventListener(eventName, handler);
        } else {
            el.attachEvent('on' + eventName, function () {
                handler.call(el);
            });
        }
    },

    /**
     * @func delegate
     * @desc 事件委托
     * @param {object} el        - 委托元素
     * @param {string} eventName - 事件类型，多个事件以逗号分隔
     * @param {string} selector  - 绑定元素选择器，仅支持属性选择器
     * @param {object} handler   - 回调函数
     */
    delegate: function (el, eventName, selector, handler) {
        var that = this;
        var eventList = eventName.split(',');

        for (var i = 0; i < eventList.length; i++) {
            this.on(el, eventList[i], function (e) {
                e = e || window.event;
                var target = e.target || e.srcElement;
                that.bubble(target, selector, handler);
            });
        }
    },

    /**
     * @func bubble
     * @desc 事件冒泡
     * @param {object} el       - 当前元素
     * @param {string} selector - 选择元素
     * @param {object} handler  - 回调函数
     */
    bubble: function (el, selector, handler) {
        var attr = selector.substr(1, selector.length - 2).split('=');
        var name = attr[0];
        var value = attr[1];

        if (el && el.getAttribute && el.getAttribute(name) === value) {
            handler.call(el);
        }

        if (el && el !== document) {
            this.bubble(el.parentNode, selector, handler);
        }
    },

    /**
     * @func imageBeacon
     * @desc 使用Image Beacon让浏览器通过GET 请求获取图片。
     */
    imageBeacon: function (src, successCallback, errorCallback) {
        var img = new Image();
        img.onload = successCallback;
        img.onerror = errorCallback;
        img.src = src;
    },

    /**
     * @func documentReady
     * @desc 页面加载完成回调
     */
    documentReady: function (fn) {
        if (document.readyState !== 'loading') {
            fn();
        } else if (window.addEventListener) {
            window.addEventListener('DOMContentLoaded', fn);
        } else {
            window.attachEvent('onreadystatechange', function () {
                if (document.readyState != 'loading') {
                    fn();
                }
            });
        }
    },

    /**
     * @func unique
     * @desc 数组去重
     */
    unique: function (arr) {
        var res = [];
        var json = {};
        for (var i = 0; i < arr.length; i++) {
            if (!json[arr[i]]) {
                res.push(arr[i]);
                json[arr[i]] = 1;
            }
        }
        return res;
    },

    /**
     * @func browserJudge
     * @desc 浏览器判断
     * @return Number 返回的url长度
     */
    getBroswer: function () {
        var Sys = {};
        var ua = navigator.userAgent.toLowerCase();
        var s;
        (s = ua.match(/edge\/([\d.]+)/)) ? Sys.edge = s[1] :
            (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
                (s = ua.match(/msie ([\d.]+)/)) ? Sys.ie = s[1] :
                    (s = ua.match(/firefox\/([\d.]+)/)) ? Sys.firefox = s[1] :
                        (s = ua.match(/chrome\/([\d.]+)/)) ? Sys.chrome = s[1] :
                            (s = ua.match(/opera.([\d.]+)/)) ? Sys.opera = s[1] :
                                (s = ua.match(/version\/([\d.]+).*safari/)) ? Sys.safari = s[1] : 
                                    (s = ua.match(/macintosh|mac os x/)) ? Sys.mac = s[0] : 0;

        if (Sys.edge) return 8182;
        if (Sys.ie) return 2048;
        if (Sys.firefox) return 8182;
        if (Sys.chrome) return 8182;
        if (Sys.opera) return 8182;
        if (Sys.safari) return 8182;
        if (Sys.mac) return 8182;

        return 4096;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/util.js
// module id = 2
// module chunks = 0